import { RPCs } from "../../../services/rpc.js";
import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { LocationName } from "../../Locations/shared/LocationName.js";
import { useRegionContext } from "../../Regions/contexts/RegionContext.js";
import { Priority } from "../../../components/Priority/Priority.js";
import "react";
import { ColorCircle, ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/SelectEvent.tsx
var SelectedSingle = (event) => /* @__PURE__ */ jsxs("div", {
	className: "inline-flex w-full items-center justify-between",
	children: [/* @__PURE__ */ jsxs("div", {
		className: "flex flex-col",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "gap-x-xs flex min-w-0 truncate",
			children: [
				/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ColorSquare, {
					color: event.eventType.color,
					marginRight: true
				}) }),
				/* @__PURE__ */ jsx("div", { children: event.title }),
				/* @__PURE__ */ jsx(Priority, { priority: event.priority })
			]
		}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(LocationName, { locationId: event.locationId }) })]
	}), /* @__PURE__ */ jsx("div", {
		className: "gap-y-xxs flex flex-col",
		children: /* @__PURE__ */ jsx(DateTime$1, {
			mode: "datetime",
			timestamp: event.date
		})
	})]
});
var SelectedMulti = (event, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "gap-x-sm px-sm inline-flex max-w-full items-center",
		children: [/* @__PURE__ */ jsx(ColorSquare, { color: event.eventType.color }), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: event.title
		})]
	})
});
var ListItem = (event) => /* @__PURE__ */ jsxs("div", {
	className: "gap-x-sm inline-flex h-full w-full items-center justify-between text-xs",
	children: [/* @__PURE__ */ jsxs("div", {
		className: "w-1/2",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs flex min-w-0 truncate",
				children: [/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ColorSquare, { color: event.eventType.color }) }), /* @__PURE__ */ jsx("div", { children: event.title })]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "flex w-full truncate",
				children: event.activityTypeTags.map((tag, i) => /* @__PURE__ */ jsxs("span", {
					className: "text-color-subtle text-xs font-medium",
					children: [tag.title, i + 2 <= event.activityTypeTags.length && ", "]
				}, tag.id))
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "text-color-subtle text-xs tracking-wide capitalize uppercase",
				children: [
					event.state,
					" - ",
					event.subTitle
				]
			})
		]
	}), /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col items-end",
		children: [
			/* @__PURE__ */ jsx(Priority, { priority: event.priority }),
			/* @__PURE__ */ jsx(DateTime$1, {
				mode: "datetime",
				timestamp: event.date
			}),
			!!event.assignedUsers[0] && /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex items-baseline",
				children: [/* @__PURE__ */ jsx("span", {
					className: "text-color-subtle text-sm tracking-wide capitalize uppercase",
					children: event.assignedUsers[0]?.status?.title
				}), /* @__PURE__ */ jsx(ColorCircle, { color: event.assignedUsers[0]?.status?.color })]
			})
		]
	})]
});
var responseOptionsExtractor = (data) => data?.events;
var SelectEvent = ({ idFilter, limit = 15, multi, value, ...atalayaSelectProps }) => {
	const regionCtx = useRegionContext();
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		idProp: "id",
		args: {
			idFilter,
			regionIds: regionCtx ? [regionCtx?.regionId] : void 0
		},
		limit,
		multi,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Events.GetEventsList.v1,
		requestFilterProp: "idFilter",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectEvent };

//# sourceMappingURL=SelectEvent.js.map